import React from "react";
import "./CreateUserTweet.scss"
import { AppContext } from '../../lib/app-context';
import { UserTweetService } from '../../services/user-tweet.service';
import { UserTweet } from '../../models/user-tweet';


interface IProps {
  productId?: number;
  parentId?: number;
  placeholder?: string;
  postSave?: any
}

interface IState {
  tweet: string;
  productId?: number;
  parentId?: number;
  placeholder?: string;
}


export default class CreateUserTweet extends React.Component<IProps, IState> {

  userTweetService: UserTweetService = new UserTweetService();

  static contextType = AppContext;

  state: IState =
    {
      tweet: '',
      productId: null,
      parentId: null,
      placeholder: ''
    }

  constructor(props: IProps) {
    super(props);
  }

  async componentDidMount() {
    let placefolder = this.props.placeholder ?? "What's happening?";

    this.setState(
      {
        parentId: this.props.parentId,
        productId: this.props.productId,
        placeholder: placefolder
      }
    );
  }



  async componentWillReceiveProps(nextProps) {

    if (this.props.productId != nextProps.productId) {
      this.setState(
        {
          productId: nextProps.productId,
        }
      );
    }

    if (this.props.parentId != nextProps.parentId) {
      this.setState(
        {
          parentId: nextProps.parentId,
        }
      );
    }

    if (this.props.placeholder != nextProps.placeholder) {

      let nextPlacefolder = nextProps.placeholder ?? "What's happening?";

      this.setState(
        {
          placeholder: nextProps.nextPlacefolder,
        }
      );
    }

  }

  postTweet() {
    let userTweet: UserTweet = new UserTweet();
    userTweet.tweet = this.state.tweet;
    userTweet.parentId = this.state.parentId;
    userTweet.productId = this.state.productId;

    this.userTweetService.createUserTweet(userTweet).then(result => {

      if (typeof this.props.postSave == "function") {
        this.props.postSave(result);
      }

      this.setState({ tweet: '' });
    });

  }


  render() {

    return (
      this.context.currentUser &&
      <div>
        <div className="card-wrapper p-2">
          <div className="d-flex">
            <div className="me-2">
              <img style={{ width: 45, height: 45 }}   className="card-img-top img-circle rounded-circle"
                src={this.context.currentUser.avatarFullURL}
                alt="Card image cap" />
            </div>
            <div className="d-flex flex-column flex-grow-1" >
              <div className="mt-1">
                <textarea className="form-control"
                  value={this.state.tweet}
                  style={{ border: "none", resize: "none" }}
                  onChange={(event) => this.setState({ tweet: event.target.value })}
                  placeholder={this.state.placeholder} rows={2}></textarea>
              </div>

              <div className="ms-auto mt-2">
                <button className="btn btn-primary" disabled={this.state.tweet == ''} onClick={() => this.postTweet()}>
                  Post
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}
